export const validate = element => {
  let error = [true, ""];
  if (element.validation.required) {
    const valid = element.value.trim() !== "";
    const message = !valid ? "this field is required" : "";
    error = [valid, message];
  }
  if (element.validation.email) {
    const valid = /\S+@\S+\.\S+/.test(element.value);
    const message = !valid ? "Must be a valid email" : "";
    error = [valid, message];
  }
  return error;
};



// WEBPACK FOOTER //
// ./src/utils/minc.js